import React, { useState } from "react";
import { api } from "../lib/api";
import { apiErrorMessage } from "../lib/pricing";
import { ShieldCheck, X } from "@phosphor-icons/react";

/** A manager types their own credentials on the cashier's screen → short-lived approval token. */
export default function ApprovalModal({ reason, onApproved, onClose }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true); setError("");
    try {
      const r = await api.post("/auth/approve", { email: email.trim(), password, purpose: "discount" });
      onApproved(r.data);
    } catch (err) {
      setError(apiErrorMessage(err));
    } finally { setBusy(false); }
  };

  return (
    <div className="fixed inset-0 bg-slate-900/70 z-50 flex items-center justify-center p-4" onClick={onClose}>
      <form onSubmit={submit} className="bg-white rounded-md shadow-2xl w-full max-w-md" onClick={(e) => e.stopPropagation()} data-testid="approval-modal">
        <div className="px-5 py-4 border-b border-slate-200 flex items-start justify-between gap-3">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-md bg-amber-100 text-amber-700 flex items-center justify-center shrink-0"><ShieldCheck size={22} weight="duotone" /></div>
            <div>
              <div className="font-display font-bold text-lg">Manager approval needed</div>
              <div className="text-xs text-slate-500 mt-0.5">{reason || "This bill exceeds your discount limit or changes a selling price."}</div>
            </div>
          </div>
          <button type="button" onClick={onClose} className="p-1.5 hover:bg-slate-100 rounded-md"><X size={16} /></button>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-xs text-slate-600">Ask a Store Manager or Admin to enter their own login below. The approval is valid for <b>5 minutes</b>, for <b>this bill only</b>, and is recorded in the audit log with their name.</p>
          <div>
            <label className="text-[10px] uppercase tracking-widest font-semibold text-slate-500 mb-1 block">Manager email</label>
            <input type="email" autoFocus value={email} onChange={(e) => setEmail(e.target.value)} data-testid="approval-email" className="w-full h-10 px-3 border border-slate-300 rounded-md text-sm" required />
          </div>
          <div>
            <label className="text-[10px] uppercase tracking-widest font-semibold text-slate-500 mb-1 block">Manager password</label>
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} data-testid="approval-password" className="w-full h-10 px-3 border border-slate-300 rounded-md text-sm" required />
          </div>
          {error && <div className="text-xs text-red-700 bg-red-50 border border-red-200 rounded-md px-3 py-2" data-testid="approval-error">{error}</div>}
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
          <button type="button" onClick={onClose} className="h-10 px-4 text-sm font-semibold text-slate-700 hover:bg-slate-100 rounded-md">Cancel</button>
          <button type="submit" disabled={busy} data-testid="approval-submit" className="h-10 px-5 bg-amber-500 hover:bg-amber-600 text-white text-sm font-bold rounded-md disabled:opacity-50">{busy ? "Verifying…" : "Approve this bill"}</button>
        </div>
      </form>
    </div>
  );
}
